import React, { useEffect, useState } from "react";
import { PiXFill } from "react-icons/pi";
import { putApi } from "../../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/toastify-message/ToastifyMessage";
import { useSelector } from "react-redux";
import { utilsState } from "../../../../sotre/redux/features/utilsSlice";
import { Form, Formik } from "formik";
import Input from "../../../../components/common/inputs/Input";
import TextArea from "../../../../components/common/inputs/TextArea";

const { forwardRef, useRef, useImperativeHandle } = React;

const EditOrderModal = forwardRef(({ productData, reGetData }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {},
  }));

  const { utils } = useSelector(utilsState);
  console.log(utils);

  const formHandler = async (values) => {
    const path = `admin/orders/${productData?._id}`;
    const body = values;
    try {
      await putApi({ path, body });
      successMessage("سفارش با موفقیت ویرایش شد");
      reGetData();
      setShowModal(false);
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showModal]);

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-[2000]  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[340px] md:w-[768px] py-4 max-h-[360px] overflow-hidden bg-white dark:bg-gray-900 mt-4 shadow-md z-[2010] rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-170px] md:mr-[-384px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between text-gray-800 dark:text-white py-4 border-b-2 sticky top-0">
          <h4>ویرایش سفارش {productData?.trackingCode}</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>
        <div className="rounded-2xl px-4 pb-3  overflow-y-scroll h-[280px]">
          <Formik
            enableReinitialize
            initialValues={{
              mobile: productData?.mobile || "",
              name: productData?.name || "",
              address: productData?.address || "",
              postcode: productData?.postcode || "",
              city: productData?.city || "",
              province: productData?.province || "",
              description: productData?.description || "",
            }}
            // validationSchema={categoryValidation}
            onSubmit={formHandler}
          >
            {(formik) => (
              <Form>
                <div className="mt-6">
                  <div className="grid gap-6 mb-6 md:grid-cols-2">
                    <Input
                      name="name"
                      placeholder="نام"
                      label="نام"
                      type="text"
                    />
                    <Input
                      name="mobile"
                      placeholder="موبایل"
                      label="موبایل"
                      type="text"
                    />
                    <Input
                      name="postcode"
                      placeholder="کد پستی"
                      label="کد پستی"
                      type="text"
                    />

                    <Input
                      name="province"
                      placeholder="استان"
                      label="استان"
                      type="text"
                    />
                    <Input
                      name="city"
                      placeholder="شهر"
                      label="شهر"
                      type="text"
                    />
                    <Input
                      name="address"
                      placeholder="آدرس"
                      label="آدرس"
                      type="text"
                    />
                  </div>
                  <TextArea
                    name="description"
                    placeholder="توضیحات"
                    label="توضیحات"
                    type="text"
                  />
                </div>

                <div className="mt-4">
                  <button
                    type="submit"
                    className="text-white text-lg bg-indigo-700 hover:bg-indigo-800 focus:outline-none focus:ring-4 focus:ring-indigo-300 font-medium rounded-full px-8 py-2.5 text-center me-2 mb-2 dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800"
                  >
                    ویرایش
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
});
export default EditOrderModal;
